import classnames from 'classnames'
import { PropsWithChildren } from 'react'
import { ItemType } from '../../slices/LogoGrid'
import classes from './LogoListCard.module.scss'

interface CardProps{
  card: ItemType
  light_bg: boolean
}

const LogoListCard: React.FC<PropsWithChildren<CardProps>> = ({ card, light_bg }) => {
  const containerStyles = [classes.cardContainer]

  if (light_bg) containerStyles.push(classes.lightMode)

  return !card?.logo?.filename? null : (
    <div className={classes.cardContainerOuter}>
      <a className={classes.cardLink} href={card.link?.cached_url} target={card?.newtab ? '_blank' : '_self'} rel="noreferrer">
        <div className={classnames(containerStyles)}>
          <div className={classes.imageContainer}>
            <img className={classes.logo} src={card?.logo?.filename || ''} alt={card?.logo?.alt || 'logo'}/>
          </div>
          <div className={classes.textContainer}>
          </div>
        </div>
      </a>
    </div>
  )
}

export default LogoListCard
